module.exports = __webpack_public_path__ + "img/colaboration-of-mn-studios.b7ed8a58.png";